import { currentUserVar } from "@/cache";
import MGContent from "@/app/app-components/MGContent/MGContent";
import { useReactiveVar } from "@apollo/client";
import { backLinkVar, pageTitleVar, backTitleVar } from "@/cache";
import "./style.css";
import { WelcomeSplash } from "./components/WelcomeSplash/WelcomeSplash";
import { HomePageClassList } from "./components/HomePageClassList/HomePageClassList";
import { useTranslation } from "react-i18next";
import useUpcomingClasses from "./components/HomePageClassList/useUpcomingClasses";
import useRecentlyEndedClasses from "./components/HomePageClassList/useRecentlyEndedClasses";
import { useStartClass } from "@/app/app-components/providers/ClassActions/useStartClass";
// import { useNavigate } from "react-router";

import { useNotification } from "@/components/notification/MGNotificationProvider/useNotification";
import { useEffect } from "react";
import { MGButton, MGLinkButton } from "@/components/buttons";
// import useClassList from "./components/HomePageClassList/useClassList";
import HomePageStudentSearch from "./components/HomePageStudentSearch/HomePageStudentSearch";
import ClassActionProvider from "@/app/app-components/providers/ClassActions";
import PermissionsService from "@/app/services/permissions/PermissionsService";
import PermissionConstants from "@/app/services/permissions/PermissionConstants";
import UserUtils from "@/app/utils/users/user_utils";
import { MGTooltip } from "@/components/tooltip";

export const HomePage = () => {
  return (
    <ClassActionProvider>
      <HomePageLayout />
    </ClassActionProvider>
  );
};

const HomePageLayout = () => {
  const currentUser = useReactiveVar(currentUserVar);

  useEffect(() => {
    backTitleVar("");
    pageTitleVar("");
    backLinkVar("");
  }, []);

  // const navigate = useNavigate();
  const [notification] = useNotification();
  const currentSchoolUser = UserUtils.getCurrentSchoolUser();

  const { t } = useTranslation();

  const upcomingClassesProps = useUpcomingClasses();
  // const inProgressClassProps = useClassList(true, false);

  const recentlyEndedClassesProps = useRecentlyEndedClasses();

  let nextClass = null;

  if (upcomingClassesProps.data && upcomingClassesProps.data[0]) nextClass = upcomingClassesProps.data[0];

  const [startClassModal] = useStartClass();

  const showStartClassModal = ({ id, screenShareMode, duration, className }) => {
    startClassModal({
      classId: id,
      screenShareMode,
      duration,
      className,
      // onSuccess: () => {
      //   notification.success({
      //     message: t("Class started successfully"),
      //   });
      //    navigate(`/teach/class/${id}`);
      // },
      onFailure: () => {
        notification.error({ message: t("Could not start class, please try again later or contact support") });
      },
    });
  };

  return (
    <MGContent>
      <div className="--mg-flex-box upcoming-recent">
        <div className="flex-1">
          <WelcomeSplash
            nextClass={nextClass}
            showStartClassModal={showStartClassModal}
            currentUser={currentUser}
          />
        </div>
        <div className="flex-1">
          <HomePageStudentSearch />
        </div>
      </div>
      <br />
      <div className="--mg-flex-box upcoming-recent">
        <div className="flex-1">
          <HomePageClassList
            heading={t("Today's upcoming classes")}
            classDataProps={upcomingClassesProps}
            redirectTo={`/plan/class/$classId`}
            emptyListMessage={t("You do not have any upcoming scheduled classes")}
            errorMessage={t("Could not load upcoming classes, please try again later or contact support")}
            actionButton={(classObj) => {
              return (
                <>
                  <MGTooltip
                    text={
                      !PermissionsService.hasPermission(PermissionConstants.StartClassOutsideSchoolHours) &&
                      !currentSchoolUser.is_in_session &&
                      t("You do not have permissions to start a class outside of school hours")
                    }
                    position={"bottom"}
                  >
                    <MGButton
                      variant="primary"
                      disabled={
                        !PermissionsService.hasPermission(PermissionConstants.StartClassOutsideSchoolHours) &&
                        !currentSchoolUser.is_in_session
                      }
                      onClick={(evt) => {
                        // evt.stopPropagation();
                        evt.preventDefault();
                        showStartClassModal({
                          id: classObj.id,
                          screenShareMode: classObj.screen_share_enabled,
                          duration: classObj.duration,
                          className: classObj.className,
                        });
                      }}
                    >
                      {t("Start Class")}
                    </MGButton>
                  </MGTooltip>
                </>
              );
            }}
          />
        </div>
        <div className="flex-1">
          <HomePageClassList
            heading={t("Recently Ended")}
            classDataProps={recentlyEndedClassesProps}
            redirectTo={`/review/class/$classId/`}
            emptyListMessage={t("You do not have any recently ended classes")}
            errorMessage={t("Could not load recently ended classes, please try again later or contact support")}
            actionButton={(classObj) => {
              return (
                <>
                  <MGLinkButton to={`/review/class/${classObj.id}/session/${classObj.sessionId}`} variant="secondary">
                    {t("Review Session")}
                  </MGLinkButton>
                </>
              );
            }}
          />
        </div>
      </div>
    </MGContent>
  );
};
